import { videoCenterHosts } from '@/constants/url';

const getVideoInfo = (url: string) => {
  if (!url) {
    return { vid: undefined };
  }

  let vid;
  let isOut;
  if (!(/^http|https|\/\//.test(url))) { // 新版编辑器存储的 vid
    vid = url;
  } else {
    const { pathname } = new URL(url);
    vid = pathname.substring(pathname.lastIndexOf('/') + 1);
    isOut = !(videoCenterHosts.find((item: string) => url.indexOf(item) >= 0));
  }

  return { vid, isOut };
};

export { getVideoInfo };
